module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-illustrations"
  }, [_c('navbar'), _vm._v(" "), _c('h2', [_vm._v("Admin Illustration")]), _vm._v(" "), _c('ul', _vm._l((_vm.illustrations), function(illustration) {
    return _c('li', [_vm._v("\n      " + _vm._s(illustration.Subject) + " "), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.open(illustration.Slug)
        }
      }
    }, [_vm._v("Edit")])], 1)
  })), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.newillustration()
      }
    }
  }, [_vm._v("Add")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec83c8b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/admin-illustrations.vue
// module id = 246
// module chunks = 1